(function () {
  'use strict';

  var CFG = window.AH_CHECKOUT || {};
  // Preview only — the authoritative amount is always computed server-side in rzp_order.php.
  // Keep these in sync with config's partial_deposit_percent / partial_min_deposit / cod_handling_fee.
  var PARTIAL_PERCENT = 50;
  var PARTIAL_MIN = 100;
  var COD_FEE = 50;
  var PROFILE_KEY = 'ahc_profile_v1';

  function api(path, body) {
    return fetch((CFG.apiBase || '').replace(/\/$/, '') + '/api/' + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body || {}),
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || j.error) { var e = new Error(j.error || 'Request failed'); e.data = j; throw e; } return j; });
    }, function () {
      throw new Error('Network issue — please check your connection and try again.');
    });
  }

  // ---- Funnel tracking (api/track.php) — fire-and-forget; must never affect the checkout. ----
  function rid() {
    var s = '';
    while (s.length < 16) s += Math.random().toString(36).slice(2);
    return s.slice(0, 16);
  }
  var CID = (function () {
    try {
      var v = localStorage.getItem('ahc_cid');
      if (!/^[a-z0-9]{16}$/.test(v || '')) { v = rid(); localStorage.setItem('ahc_cid', v); }
      return v;
    } catch (e) { return rid(); }
  })();
  // A/B test: on the phone step, arm "b" also shows the items and order total in the card (arm "a" =
  // summary bar only). The arm is derived from CID so a device always sees the same version; every
  // funnel event carries it as `ab` (tools/ab_report.php).
  var AB_PHONE = (function () {
    var m = /[?&]ahc_ab=([ab])\b/.exec(window.location.search);
    try {
      if (m) localStorage.setItem('ahc_ab_force', m[1]);
      var f = localStorage.getItem('ahc_ab_force');
      if (f === 'a' || f === 'b') return f;
    } catch (e) { /* private mode */ }
    return parseInt(CID.charAt(15), 36) % 2 ? 'b' : 'a';
  })();
  // "os/browser", e.g. android/fb-app, ios/safari — in-app browsers (Facebook/Instagram ads) handle
  // UPI app launches and popups differently, so the funnel is split by this.
  var BROWSER = (function () {
    var ua = navigator.userAgent || '';
    var os = /iPhone|iPad|iPod/.test(ua) ? 'ios' : /Android/.test(ua) ? 'android' : 'desktop';
    var b = /FBAN|FBAV|FB_IAB|FBIOS/.test(ua) ? 'fb-app'
      : /Instagram/.test(ua) ? 'insta-app'
      : /GSA\//.test(ua) ? 'google-app'
      : /SamsungBrowser/.test(ua) ? 'samsung'
      : /EdgA?\/|Edg\//.test(ua) ? 'edge'
      : /CriOS/.test(ua) ? 'chrome'
      : /; wv\)/.test(ua) ? 'webview'
      : /Firefox|FxiOS/.test(ua) ? 'firefox'
      : /Chrome\//.test(ua) ? 'chrome'
      : /Safari\//.test(ua) ? 'safari' : 'other';
    return os + '/' + b;
  })();
  function track(event, data) {
    try {
      var body = JSON.stringify(Object.assign({
        cid: CID, attempt: state.attempt || rid(), event: event, entry: state.entry, token: state.token, br: BROWSER,
        path: window.location.pathname, mobile: window.matchMedia('(max-width: 749px)').matches, ab: 'phone-total-' + AB_PHONE,
      }, data || {}));
      var url = (CFG.apiBase || '').replace(/\/$/, '') + '/api/track.php';
      // text/plain keeps it a "simple" request (no CORS preflight) and lets sendBeacon survive page unloads.
      if (!(navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' })))) {
        fetch(url, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
      }
    } catch (e) { /* never break checkout over tracking */ }
  }
  function cartAmount() {
    var t = state.totals || {};
    var total = t.total_amount != null ? t.total_amount : itemsSubtotal();
    return total == null ? null : total;
  }
  function itemsLabel() {
    return (state.items || []).map(function (i) { return i.title + (i.variant ? ' (' + i.variant + ')' : '') + ' x' + i.qty; }).join(', ') ||
      (state.lines || []).map(function (l) { return (l.title || l.variant_id) + ' x' + l.quantity; }).join(', ');
  }

  function load(key) { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; } }
  function save(key, v) { try { localStorage.setItem(key, JSON.stringify(v)); } catch (e) { /* private mode */ } }

  // ---- Ad & analytics pixels ---------------------------------------------------------
  // Orders are created via the Admin API, so the buyer never reaches Shopify's checkout pages —
  // where the Google & YouTube and Facebook & Instagram app pixels fired begin_checkout/purchase.
  // We fire them ourselves, to the same destinations those apps used (see the store's
  // webPixelsConfigList). Every call is wrapped: tracking must never affect the checkout.
  //   GA4 (G-NZCWT47EQ0)      — dataLayer events, sent by GTM-W2WDGKW's ecommerce event tag
  //   Google Ads + Merchant Ctr — gtag.js, the Google app's own conversion labels
  //   Meta (485428047913588)  — fbevents.js; Purchase also goes server-side via CAPI (same event id)
  var ADS = {
    aw: 'AW-803916389',
    mc: 'MC-YZR3KVPYJF',
    beginCheckout: ['AW-803916389/Qg8dCJar69AZEOWUq_8C'],
    addPaymentInfo: ['AW-803916389/om4MCJmr69AZEOWUq_8C'],
    purchase: ['AW-803916389/MFPzCIer69AZEOWUq_8C', 'AW-803916389/-cmyCPmk7IMBEOWUq_8C', 'MC-YZR3KVPYJF'],
    metaPixel: '485428047913588',
  };

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  var gtagStarted = false;
  function gtag() { window.dataLayer.push(arguments); } // must push the Arguments object itself
  function gtagInit() {
    window.dataLayer = window.dataLayer || [];
    if (gtagStarted) return;
    gtagStarted = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + ADS.aw;
    document.head.appendChild(s);
    gtag('js', new Date());
    // The app pixel already sends page views; config here is for the conversion linker
    // (_gcl_* cookies) and so conversions below have a destination.
    gtag('config', ADS.aw, { send_page_view: false, allow_enhanced_conversions: true });
    gtag('config', ADS.mc, { send_page_view: false });
  }

  var fbqStarted = false;
  function fbqInit(match) {
    /* eslint-disable */
    if (!window.fbq) !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    if (fbqStarted) return;
    fbqStarted = true;
    window.fbq('set', 'autoConfig', false, ADS.metaPixel); // no automatic button-click events
    window.fbq('init', ADS.metaPixel, match || {});
  }

  function dlPush(event, ecommerce, extra) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object (GTM merges)
    window.dataLayer.push(Object.assign({ event: event, ecommerce: ecommerce }, extra || {}));
  }

  // Click ids + UTMs from the ad landing page, kept across pages (the buyer usually browses
  // before checking out, and the checkout page's own URL has none). 90-day click window,
  // 30 days for UTMs. Sent with the quote → stored on the session and the Shopify order.
  var CLICK_KEY = 'ahc_click_v1';
  var CLICK = (function () {
    var saved = load(CLICK_KEY) || {};
    try {
      var now = Date.now();
      Object.keys(saved).forEach(function (k) {
        var max = (k === 'landing' ? 30 : 90) * 864e5;
        if (!saved[k] || !saved[k].at || now - saved[k].at > max) delete saved[k];
      });
      var q = new URLSearchParams(window.location.search);
      var hit = false;
      ['gclid', 'gbraid', 'wbraid', 'fbclid'].forEach(function (k) {
        var v = q.get(k);
        if (v) { saved[k] = { v: v.slice(0, 255), at: now }; hit = true; }
      });
      var utm = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { if (q.get(k)) utm[k] = q.get(k); });
      if (utm.utm_source || hit) saved.landing = { v: utm, at: now };
      if (q.get('fbclid') && cookie('_fbc').indexOf(q.get('fbclid')) === -1) {
        // Same value fbevents.js would set; the Meta app pixel runs sandboxed, so set it ourselves.
        document.cookie = '_fbc=' + encodeURIComponent('fb.1.' + now + '.' + q.get('fbclid')) + '; path=/; max-age=7776000; SameSite=Lax' +
          (/abanahomes\.com$/.test(window.location.hostname) ? '; domain=.abanahomes.com' : '');
      }
      save(CLICK_KEY, saved);
      if (q.get('gclid') || q.get('gbraid') || q.get('wbraid')) gtagInit(); // let the conversion linker store it too
    } catch (e) { /* never break the page over tracking */ }
    return saved;
  })();
  function clickIds() {
    var v = function (k) { return (CLICK[k] && CLICK[k].v) || ''; };
    return {
      gclid: v('gclid'), gbraid: v('gbraid'), wbraid: v('wbraid'), fbclid: v('fbclid'),
      fbc: cookie('_fbc') || (CLICK.fbclid ? 'fb.1.' + CLICK.fbclid.at + '.' + CLICK.fbclid.v : ''),
      fbp: cookie('_fbp'),
    };
  }

  function variantNum(id) { return String(id).replace('gid://shopify/ProductVariant/', ''); }
  // Google: Merchant Center feed id. Meta: its Shopify catalogs use the bare variant id.
  function feedId(productId, variantId) { return productId ? 'shopify_IN_' + productId + '_' + variantNum(variantId) : variantNum(variantId); }
  function cartAdItems() {
    return (state.lines || []).map(function (l, i) {
      var it = (state.items || [])[i] || {};
      var q = l.quantity || 1;
      return { id: feedId(l.product_id, l.variant_id), item_id: feedId(l.product_id, l.variant_id), variant: variantNum(l.variant_id),
        item_name: it.title || l.title || '', price: it.line ? it.line / (it.qty || q) : undefined, quantity: q };
    });
  }
  function metaContents(items) {
    return items.map(function (i) { return { id: i.variant, quantity: i.quantity, item_price: i.price }; });
  }

  function pixelBeginCheckout() {
    try {
      var items = cartAdItems();
      var value = cartAmount() || 0;
      dlPush('begin_checkout', { currency: 'INR', value: value, items: items });
      gtagInit();
      gtag('event', 'begin_checkout', { send_to: ADS.beginCheckout, value: value, currency: 'INR', items: items });
      fbqInit();
      window.fbq('track', 'InitiateCheckout', { value: value, currency: 'INR', content_type: 'product',
        content_ids: items.map(function (i) { return i.variant; }), contents: metaContents(items), num_items: items.length });
    } catch (e) { /* never break checkout over tracking */ }
  }

  function pixelAddPaymentInfo(value, method) {
    try {
      var items = cartAdItems();
      dlPush('add_payment_info', { currency: 'INR', value: value, payment_type: method, items: items });
      gtagInit();
      gtag('event', 'add_payment_info', { send_to: ADS.addPaymentInfo, value: value, currency: 'INR', items: items });
      fbqInit();
      window.fbq('track', 'AddPaymentInfo', { value: value, currency: 'INR', content_type: 'product',
        content_ids: items.map(function (i) { return i.variant; }) });
    } catch (e) { /* never break checkout over tracking */ }
  }

  // Called by the order-confirmed page (templates/page.ah-checkout-confirmation.liquid) with
  // order_status.php's order. Fires once per order per browser; transaction_id / eventID = the
  // Shopify order name, which Google/GA4 and Meta (vs the server-side CAPI event) dedupe on.
  function trackPurchase(o) {
    try {
      if (!o || !o.name) return;
      var key = 'ahc_px_' + o.name;
      if (load(key)) return;
      save(key, 1);
      var items = (o.items || []).map(function (l) {
        return { id: feedId(l.product_id, l.variant_id), item_id: feedId(l.product_id, l.variant_id), variant: variantNum(l.variant_id),
          item_name: l.title || '', price: l.price != null ? Number(l.price) : undefined, quantity: l.quantity || 1 };
      });
      var value = Number(o.total_amount) || 0;
      var name = String(o.customer_name || '').trim().toLowerCase().split(/\s+/);
      var phone = o.phone ? '+91' + o.phone : '';
      var email = (o.email || '').trim().toLowerCase();

      dlPush('purchase', {
        transaction_id: o.name, value: value, currency: 'INR', tax: o.tax_amount, shipping: o.shipping_amount,
        coupon: o.discount_label || undefined, items: items,
      }, { email: email || undefined, phone: phone || undefined, first_name: name[0] || undefined,
        last_name: name.slice(1).join(' ') || undefined, city: o.city, zip: o.pincode, country: 'IN' });

      gtagInit();
      gtag('set', 'user_data', {
        email: email || undefined, phone_number: phone || undefined,
        address: { first_name: name[0] || undefined, last_name: name.slice(1).join(' ') || undefined, city: o.city, postal_code: o.pincode, country: 'IN' },
      });
      gtag('event', 'purchase', { send_to: ADS.purchase, transaction_id: o.name, value: value, currency: 'INR', items: items });

      fbqInit({ em: email || undefined, ph: phone ? phone.slice(1) : undefined, fn: name[0] || undefined,
        ln: name.slice(1).join(' ') || undefined, ct: (o.city || '').toLowerCase().replace(/[^a-z]/g, '') || undefined,
        zp: o.pincode || undefined, country: 'in' });
      window.fbq('track', 'Purchase', { value: value, currency: 'INR', content_type: 'product', order_id: o.name,
        content_ids: items.map(function (i) { return i.variant; }), contents: metaContents(items),
        num_items: items.reduce(function (n, i) { return n + i.quantity; }, 0) }, { eventID: o.name });
    } catch (e) { /* never break the page over tracking */ }
  }

  function money(amount) {
    // Shopify's shop.money_format has several placeholder variants — we fully control this UI,
    // so just format INR directly.
    return '₹' + Math.round(Number(amount)).toLocaleString('en-IN');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(src, w) {
    if (!src || src.indexOf('data:') === 0) return src || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }


  var I = {
    back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="4.5" y="10.5" width="15" height="10" rx="2.5"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3 4.5 6v5.5c0 4.6 3.1 8.1 7.5 9.5 4.4-1.4 7.5-4.9 7.5-9.5V6z"/><path d="m9 12 2.2 2.2L15.5 10"/></svg>',
    chevron: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1 12H6z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>',
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s7-6 7-11.5a7 7 0 0 0-14 0C5 15 12 21 12 21Z"/><circle cx="12" cy="9.5" r="2.5"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h11v10H3zM14 9h4l3 3.5V16h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    alert: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5h.01"/></svg>',
    card: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5.5" width="18" height="13" rx="2.5"/><path d="M3 10h18M7 15h3"/></svg>',
    phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="6.5" y="2.5" width="11" height="19" rx="2.5"/><path d="M11 18.5h2"/></svg>',
    home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 10.5 12 4l8.5 6.5V20a1 1 0 0 1-1 1h-5v-6h-5v6h-5a1 1 0 0 1-1-1z"/></svg>',
    user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4.5 20.5a7.5 7.5 0 0 1 15 0"/></svg>',
    mail: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="m3.5 6.5 8.5 6.5 8.5-6.5"/></svg>',
    bank: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9.5 12 4l9 5.5M4.5 10v8M9.5 10v8M14.5 10v8M19.5 10v8M3 20.5h18"/></svg>',
    wallet: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M19 7V5.5A1.5 1.5 0 0 0 17.5 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2H5"/><circle cx="16.5" cy="13.5" r="1.2" fill="currentColor"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12V4.5A1.5 1.5 0 0 1 4.5 3H12l9 9-9 9z"/><circle cx="7.5" cy="7.5" r="1.4"/></svg>',
    spark: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6"/></svg>',
    flagIN: '<svg viewBox="0 0 30 20"><rect width="30" height="20" fill="#fff"/><rect width="30" height="6.67" fill="#FF9933"/><rect y="13.33" width="30" height="6.67" fill="#138808"/><circle cx="15" cy="10" r="2.6" fill="none" stroke="#000080" stroke-width=".7"/><circle cx="15" cy="10" r=".6" fill="#000080"/></svg>',
    india: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>',
  };

  var MARK = {
    upi: '<svg viewBox="0 0 54 20" aria-label="UPI"><text x="0" y="16" font-family="Arial,Helvetica,sans-serif" font-weight="900" font-style="italic" font-size="17" fill="#5f6062">UPI</text><path d="M38 2.5l7.5 7.5-7.5 7.5z" fill="#0b8a43"/><path d="M44 2.5l7.5 7.5-7.5 7.5z" fill="#f47920"/></svg>',
    visa: '<svg viewBox="0 0 46 16" aria-label="Visa"><text x="0" y="14" font-family="Arial,Helvetica,sans-serif" font-weight="900" font-style="italic" font-size="16" letter-spacing="-.4" fill="#1a1f71">VISA</text></svg>',
    mc: '<svg viewBox="0 0 30 18" aria-label="Mastercard"><circle cx="10.5" cy="9" r="8" fill="#eb001b"/><circle cx="19.5" cy="9" r="8" fill="#f79e1b"/><path d="M15 2.4a8 8 0 0 1 0 13.2 8 8 0 0 1 0-13.2z" fill="#ff5f00"/></svg>',
    rupay: '<svg viewBox="0 0 60 16" aria-label="RuPay"><text x="0" y="13.5" font-family="Arial,Helvetica,sans-serif" font-weight="900" font-style="italic" font-size="15" fill="#1b3f8f">RuPay</text><path d="M48 2l5.5 6-5.5 6z" fill="#128a3e"/><path d="M53 2l5.5 6-5.5 6z" fill="#f7941d"/></svg>',
  };
  // Selectable — the pick is passed to Razorpay as prefill.method so its sheet opens on that
  // method instead of a list with nothing chosen. UPI by default (~90% of our payments).
  // Phones: one tap on a UPI app opens that app directly with the amount filled in (Razorpay
  // Custom Checkout "UPI Intent", razorpay.js createPayment(..., {app})) — Razorpay's standard
  // sheet makes customers pick an app before its Continue button does anything, and people
  // were leaving there. Desktop (no intent support) keeps the standard sheet.
  var UPI_APPS = [
    { id: 'phonepe', name: 'PhonePe', logo: 'https://cdn.razorpay.com/app/phonepe.svg' },
    { id: 'paytm', name: 'Paytm', logo: 'https://cdn.razorpay.com/app/paytm.svg' },
    { id: 'gpay', name: 'Google Pay', logo: 'https://cdn.razorpay.com/app/googlepay.svg' },
    { id: 'cred', name: 'CRED', logo: 'https://cdn.razorpay.com/app/cred.svg' },
  ];
  function upiAppName(id) {
    var a = UPI_APPS.filter(function (x) { return x.id === id; })[0];
    return a ? a.name : 'UPI app';
  }
  // checkout.js (standard sheet) and razorpay.js (custom) both define window.Razorpay — load the
  // custom one on demand, keep its constructor privately, and hand the global back to checkout.js.
  var RzpCustom = null;
  var rzpCustomLoading = null;
  function loadRzpCustom() {
    if (RzpCustom) return Promise.resolve(RzpCustom);
    if (rzpCustomLoading) return rzpCustomLoading;
    rzpCustomLoading = new Promise(function (resolve, reject) {
      var std = window.Razorpay;
      var s = document.createElement('script');
      s.src = 'https://checkout.razorpay.com/v1/razorpay.js';
      s.onload = function () {
        RzpCustom = window.Razorpay;
        if (std) window.Razorpay = std;
        resolve(RzpCustom);
      };
      s.onerror = function () { rzpCustomLoading = null; reject(new Error('razorpay.js failed to load')); };
      document.head.appendChild(s);
    });
    return rzpCustomLoading;
  }
  // Which app buttons this device can open — Razorpay's own per-platform list (empty on desktop).
  var upiAppsCache = null; // per page — survives startWith()'s state reset
  function detectUpiApps() {
    if (upiAppsCache) return Promise.resolve(state.upiApps = upiAppsCache);
    return loadRzpCustom().then(function (R) {
      return new R({ key: CFG.razorpayKeyId }).getSupportedUpiIntentApps();
    }).then(function (list) {
      list = list || [];
      return { apps: UPI_APPS.filter(function (a) { return list.indexOf(a.id) > -1; }).map(function (a) { return a.id; }), any: list.indexOf('any') > -1 };
    }).catch(function () { return { apps: [], any: false }; })
      .then(function (u) { upiAppsCache = state.upiApps = u; return u; });
  }

  // What the Pay button does when nothing is tapped. Android: the phone's own UPI app chooser,
  // which lists every installed UPI app (not everyone has Google Pay). iPhone has no chooser, so
  // the first app (PhonePe). Desktop can't open an app at all, so a QR code to scan.
  var IS_DESKTOP = BROWSER.indexOf('desktop/') === 0;
  function defaultMethod() {
    var u = state.upiApps;
    if (u && u.any) return 'upi:any';
    if (u && u.apps.length) return 'upi:' + u.apps[0];
    return IS_DESKTOP ? 'upi:qr' : 'upi';
  }

  function methodTiles() {
    var apps = state.upiApps && state.upiApps.apps.length ? state.upiApps : null;
    var cur = state.payMethod || defaultMethod();
    function tile(method, logos, name, cls) {
      return '<button type="button" class="ahc-mtile' + (cls ? ' ' + cls : '') + (cur === method ? ' is-selected' : '') + '" data-method="' + method + '" aria-pressed="' + (cur === method) + '">' +
        '<div class="ahc-mtile-logos">' + logos + '</div><div class="ahc-mtile-name">' + name + '</div></button>';
    }
    var others = tile('card', MARK.visa + MARK.mc, 'Cards') +
      tile('netbanking', '<span class="ahc-glyph">' + I.bank + '</span>', 'Netbanking') +
      tile('wallet', '<span class="ahc-glyph">' + I.wallet + '</span>', 'Wallets');
    if (!apps && IS_DESKTOP) {
      return '<div class="ahc-pay-label is-hot">Scan a QR code with any UPI app to pay</div>' +
        '<div class="ahc-methods">' + tile('upi:qr', MARK.upi, 'UPI QR', 'is-app') + others + '</div>' +
        '<div class="ahc-qr-slot"></div>';
    }
    if (!apps) return '<div class="ahc-methods">' + tile('upi', MARK.upi, 'UPI') + others + '</div>';
    return '<div class="ahc-pay-label is-hot">Tap your UPI app to pay</div>' +
      '<div class="ahc-methods ahc-apps">' +
        // Android: the system chooser first — it covers every UPI app on the phone.
        (apps.any ? tile('upi:any', MARK.upi, 'Any UPI app', 'is-app') : '') +
        apps.apps.map(function (id) {
          var a = UPI_APPS.filter(function (x) { return x.id === id; })[0];
          return tile('upi:' + id, '<img src="' + a.logo + '" alt="" width="26" height="26" loading="lazy">', a.name, 'is-app');
        }).join('') +
        // iPhone has no chooser: "Other UPI app" opens Razorpay's UPI list instead.
        (apps.any ? '' : tile('upi', MARK.upi, 'Other UPI app', 'is-app')) +
      '</div>' +
      '<div class="ahc-pay-label">Or pay with</div>' +
      '<div class="ahc-methods">' + others + '</div>';
  }

  function bindMethodTiles(pane) {
    pane.querySelectorAll('.ahc-mtile').forEach(function (b) {
      b.addEventListener('click', function () {
        state.payMethod = b.getAttribute('data-method');
        if (state.payView) state.payView.taps.push(state.payMethod);
        pane.querySelectorAll('.ahc-mtile').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-selected', on);
          x.setAttribute('aria-pressed', String(on));
        });
        // A UPI app is one tap: pay straight away. Cards/netbanking/wallets just select and wait
        // for the Pay button, as before.
        if ((b.classList.contains('is-app') || state.payMethod === 'upi:qr') && !ui.btn.disabled) startPayment();
      });
    });
  }

  var state = {};
  var ui = null;
  var ctaFn = null;
  var backFn = null;
  var STEPS = { phone: 0, address: 1, pay: 2 };

  // ---- Shell ------------------------------------------------------------------------

  function build() {
    if (ui) return ui;
    var name = CFG.shopName || 'Abana Homes';
    var mark = CFG.logo
      ? '<img src="' + esc(CFG.logo) + '" alt="">'
      : esc(name.trim().charAt(0).toUpperCase());
    var root = document.createElement('div');
    root.id = 'ah-checkout-overlay';
    root.className = 'ah-checkout-overlay';
    root.hidden = true;
    root.innerHTML =
      '<div class="ahc-panel" role="dialog" aria-modal="true" aria-label="Checkout">' +
        '<div class="ahc-head">' +
          '<div class="ahc-head-row">' +
            '<button type="button" class="ahc-icon-btn" data-ahc="back" aria-label="Back" data-hidden>' + I.back + '</button>' +
            '<div class="ahc-brand"><div class="ahc-brand-mark">' + mark + '</div>' +
              '<div style="min-width:0"><div class="ahc-brand-name">' + esc(name) + '</div>' +
              '<div class="ahc-brand-sub">' + I.lock + 'Secure checkout</div></div></div>' +
            '<button type="button" class="ahc-icon-btn" data-ahc="close" aria-label="Close checkout">' + I.close + '</button>' +
          '</div>' +
          '<div class="ahc-steps"><div class="ahc-step">Mobile</div><div class="ahc-step">Address</div><div class="ahc-step">Payment</div></div>' +
        '</div>' +
        '<div class="ahc-summary">' +
          '<button type="button" class="ahc-summary-toggle" aria-expanded="false">' +
            '<div class="ahc-thumbs"></div>' +
            '<div class="ahc-sum-text"><div class="ahc-sum-title">Order summary' + I.chevron + '</div><div class="ahc-sum-count"></div></div>' +
            '<div class="ahc-sum-total"><div class="ahc-sum-strike"></div><div class="ahc-sum-price"></div></div>' +
          '</button>' +
          '<div class="ahc-summary-body"><div class="ahc-summary-inner"><div class="ahc-summary-content"></div></div></div>' +
        '</div>' +
        '<div class="ahc-body"><div class="ahc-pane"></div></div>' +
        '<div class="ahc-foot">' +
          '<div class="ahc-alert" role="alert" hidden></div>' +
          '<button type="button" class="ahc-btn"><span class="ahc-btn-label"></span><span class="ahc-spin"></span></button>' +
          '<div class="ahc-fine">' + I.lock + 'Payments secured by <b>Razorpay</b> · 256-bit SSL</div>' +
        '</div>' +
        '<div class="ahc-processing" hidden><div class="ahc-spin"></div><h3>Confirming your payment</h3><p>This takes a few seconds. Please don\'t close or refresh this page.</p></div>' +
      '</div>';
    document.body.appendChild(root);

    ui = {
      root: root,
      panel: root.querySelector('.ahc-panel'),
      back: root.querySelector('[data-ahc="back"]'),
      steps: root.querySelectorAll('.ahc-step'),
      summary: root.querySelector('.ahc-summary'),
      toggle: root.querySelector('.ahc-summary-toggle'),
      body: root.querySelector('.ahc-body'),
      pane: root.querySelector('.ahc-pane'),
      alert: root.querySelector('.ahc-alert'),
      btn: root.querySelector('.ahc-btn'),
      processing: root.querySelector('.ahc-processing'),
    };
    ui.body.addEventListener('scroll', payViewScroll, { passive: true });
    root.querySelector('[data-ahc="close"]').addEventListener('click', close);
    ui.back.addEventListener('click', function () { if (backFn) backFn(true); });
    ui.btn.addEventListener('click', function () { if (ctaFn && !ui.btn.disabled) { hideAlert(); ctaFn(); } });
    ui.toggle.addEventListener('click', function () {
      var openNow = !ui.summary.classList.contains('is-open');
      ui.summary.classList.toggle('is-open', openNow);
      ui.toggle.setAttribute('aria-expanded', String(openNow));
    });
    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
    return ui;
  }

  // Payment-step exit, sent once per view when the customer leaves it without tapping pay:
  // what they were shown, how far they scrolled, how long they stayed, which tiles they touched.
  function payViewStart() {
    state.payView = { t0: Date.now(), scroll: 0, taps: [], done: false };
    payViewScroll();
  }
  function payViewScroll() {
    var v = state.payView;
    if (!v || !ui || state.step !== 'pay') return;
    var b = ui.body;
    var pct = b.scrollHeight > 0 ? Math.round(Math.min(1, (b.scrollTop + b.clientHeight) / b.scrollHeight) * 100) : 100;
    if (pct > v.scroll) v.scroll = pct;
  }
  function payExit(how) {
    var v = state.payView;
    if (!v || v.done) return;
    v.done = true;
    var u = state.upiApps;
    var shown = u && u.apps.length ? u.apps.join(',') + (u.any ? ',any' : ',upi') : (u ? 'std' : 'loading');
    var t = state.totals || {};
    var off = t.discount_code ? ' code=' + t.discount_code : (state.totals && offerFor(t) ? ' offer-shown' : '');
    track('pay_exit', { amount: cartAmount(), detail: (how + off + ' shown=' + shown + ' scroll=' + v.scroll + '% secs=' +
      Math.round((Date.now() - v.t0) / 1000) + (v.taps.length ? ' taps=' + v.taps.join(',') : '')).slice(0, 255) });
  }
  function stepSecs() { return state.stepT0 ? Math.round((Date.now() - state.stepT0) / 1000) : 0; }
  function stepExit(how) {
    if (!ui || ui.root.hidden || !state.step || state.step === 'pay' || state.exitSent) return;
    state.exitSent = true;
    track('step_exit', { detail: state.step + ' ' + how + ' secs=' + stepSecs(), amount: cartAmount() });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') stepExit('hidden');
    else state.exitSent = false; // came back — a later exit from this step counts again
  });
  window.addEventListener('pagehide', function () { stepExit('pagehide'); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden' && state.step === 'pay' && ui && !ui.root.hidden) payExit('hidden');
  });

  function showStep(name, html, isBack, still) {
    if (state.step === 'pay' && name !== 'pay') payExit('back');
    state.step = name;
    state.stepT0 = Date.now();
    state.exitSent = false;
    var idx = STEPS[name];
    Array.prototype.forEach.call(ui.steps, function (s, i) {
      s.classList.toggle('is-done', idx != null && i < idx);
      s.classList.toggle('is-active', i === idx);
    });
    hideAlert();
    // Re-create the pane so its entry animation replays on every step change.
    var fresh = ui.pane.cloneNode(false);
    fresh.className = 'ahc-pane' + (isBack ? ' is-back' : '') + (still ? ' is-still' : '');
    fresh.innerHTML = html;
    ui.pane.parentNode.replaceChild(fresh, ui.pane);
    ui.pane = fresh;
    if (!still) ui.body.scrollTop = 0;
    return fresh;
  }

  function setBack(fn) {
    backFn = fn;
    if (fn) ui.back.removeAttribute('data-hidden'); else ui.back.setAttribute('data-hidden', '');
  }

  function setCta(label, fn, opts) {
    opts = opts || {};
    ctaFn = fn;
    ui.btn.classList.remove('is-loading');
    ui.btn.disabled = !!opts.disabled;
    ui.btn.querySelector('.ahc-btn-label').innerHTML = (opts.lock ? I.lock : '') + '<span>' + esc(label) + '</span>';
  }

  function ctaLoading(on) {
    ui.btn.classList.toggle('is-loading', on);
    ui.btn.disabled = on;
  }

  function showAlert(msg) {
    track('alert', { detail: (state.step || '') + ': ' + msg });
    ui.alert.innerHTML = I.alert + '<span>' + esc(msg) + '</span>';
    ui.alert.hidden = false;
    // Restart the shake animation on repeat errors.
    ui.alert.style.animation = 'none'; void ui.alert.offsetWidth; ui.alert.style.animation = '';
  }
  function hideAlert() { if (ui) ui.alert.hidden = true; }

  function fieldError(input, msg) {
    var field = input.closest('.ahc-field');
    field.classList.toggle('is-invalid', !!msg);
    var m = field.parentNode.querySelector('[data-msg-for="' + input.name + '"]');
    if (m) { m.className = 'ahc-field-msg'; m.textContent = msg || ''; }
  }

  // Order matters: the label must directly follow the control (floating-label CSS uses `+`).
  function field(name, label, value, attrs, icon, multiline) {
    var ctl = multiline
      ? '<textarea name="' + name + '" id="ahc-f-' + name + '" placeholder=" " rows="2" ' + (attrs || '') + '>' + esc(value || '') + '</textarea>'
      : '<input name="' + name + '" id="ahc-f-' + name + '" placeholder=" " value="' + esc(value || '') + '" ' + (attrs || '') + '>';
    return '<div class="ahc-field">' + ctl + '<label for="ahc-f-' + name + '">' + label + '</label>' +
      (icon ? '<span class="ahc-field-ico">' + icon + '</span>' : '') +
      '<span class="ahc-field-ok">' + I.check + '</span></div>' +
      '<p class="ahc-field-msg" data-msg-for="' + name + '"></p>';
  }

  function markValid(input, ok) { input.closest('.ahc-field').classList.toggle('is-valid', !!ok); }

  // ---- Order summary ------------------------------------------------------------------

  function thumb(item, cls) {
    var bg = item && item.image ? ' style="background-image:url(\'' + esc(sized(item.image, 160)) + '\')"' : '';
    return '<div class="ahc-thumb ' + (cls || '') + '"' + bg + '>' + (item && item.image ? '' : I.bag) +
      (cls === 'with-qty' ? '<span class="ahc-qty">' + item.qty + '</span>' : '') + '</div>';
  }

  function itemsSubtotal() {
    if (!state.items || !state.items.length) return null;
    return state.items.reduce(function (n, i) { return n + i.line; }, 0);
  }

  // Before Shopify has priced the cart, fall back to what the theme cart already showed.
  function discountOf(t) {
    if (t.discount_amount != null) return { amount: t.discount_amount, label: t.discount_label };
    return state.preDiscount || { amount: 0, label: null };
  }

  // Partial-COD adds the COD fee on top of Shopify's total, so the customer sees what they'll
  // pay in all (deposit now + balance on delivery) rather than two numbers that don't add up.
  function codFeeOf(t) {
    return state.paymentMode === 'partial' && t.total_amount != null ? COD_FEE : 0;
  }

  function totalOf(t) {
    if (t.total_amount != null) return t.total_amount + codFeeOf(t);
    var sub = t.subtotal_amount != null ? t.subtotal_amount : itemsSubtotal();
    return sub == null ? null : sub - discountOf(t).amount;
  }

  function billRows(t) {
    var sub = t.subtotal_amount != null ? t.subtotal_amount : itemsSubtotal();
    var hasShip = t.shipping_amount != null;
    var d = discountOf(t);
    var rows = '';
    if (sub != null) rows += '<div class="ahc-bill-row"><span>Subtotal</span><b>' + money(sub) + '</b></div>';
    if (d.amount > 0) {
      rows += '<div class="ahc-bill-row is-discount"><span>Discount' + (d.label ? ' <span class="ahc-disc-tag">' + esc(d.label) + '</span>' : '') +
        '</span><b>−' + money(d.amount) + '</b></div>';
    }
    rows += hasShip
      ? '<div class="ahc-bill-row"><span>Shipping</span>' + (t.shipping_amount > 0 ? '<b>' + money(t.shipping_amount) + '</b>' : '<span class="ahc-free">FREE</span>') + '</div>'
      : '<div class="ahc-bill-row is-pending"><span>Shipping</span><b>Calculated after address</b></div>';
    if (t.tax_amount > 0) rows += '<div class="ahc-bill-row"><span>Taxes</span><b>' + money(t.tax_amount) + '</b></div>';
    if (codFeeOf(t)) rows += '<div class="ahc-bill-row"><span>COD fee</span><b>' + money(COD_FEE) + '</b></div>';
    var total = totalOf(t);
    if (total != null) rows += '<div class="ahc-bill-row is-total"><span>' + (hasShip ? 'Total' : 'Estimated total') + '</span><b>' + money(total) + '</b></div>';
    return rows;
  }

  function renderSummary() {
    if (!ui) return;
    var items = state.items || [];
    var count = state.lines.reduce(function (n, l) { return n + (l.quantity || 1); }, 0);
    var t = state.totals || {};
    var total = totalOf(t);
    // Strike-through = the higher of MRP (compare-at) and pre-discount subtotal, whenever it beats the total.
    var compare = Math.max(items.reduce(function (n, i) { return n + Math.max(i.compare || 0, i.line); }, 0),
      t.subtotal_amount != null ? t.subtotal_amount : 0);

    ui.root.querySelector('.ahc-thumbs').innerHTML = items.length
      ? items.slice(0, 3).map(function (i) { return thumb(i); }).join('')
      : thumb(null);
    ui.root.querySelector('.ahc-sum-count').textContent = count + ' item' + (count === 1 ? '' : 's');
    ui.root.querySelector('.ahc-sum-price').textContent = total != null ? money(total) : '';
    ui.root.querySelector('.ahc-sum-strike').textContent = total != null && compare > total ? money(compare) : '';

    ui.root.querySelector('.ahc-summary-content').innerHTML =
      items.map(function (i) {
        return '<div class="ahc-line">' + thumb(i, 'with-qty') +
          '<div class="ahc-line-text"><div class="ahc-line-title">' + esc(i.title) + '</div>' +
          (i.variant ? '<div class="ahc-line-variant">' + esc(i.variant) + '</div>' : '') + '</div>' +
          '<div class="ahc-line-price">' + money(i.line) + '</div></div>';
      }).join('') +
      '<div class="ahc-bill">' + billRows(t) + '</div>';
    var po = state.step === 'phone' && ui.pane.querySelector('.ahc-phone-order');
    if (po) { po.innerHTML = phoneOrderHtml(); po.hidden = !po.innerHTML; }
  }

  // ---- Open / close -------------------------------------------------------------------

  function open() {
    build();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active') && typeof drawer.close === 'function') drawer.close();
    ui.processing.hidden = true;
    ui.summary.classList.remove('is-open');
    ui.root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { ui.root.classList.add('ahc-in'); }); });
    renderSummary();
  }

  function close() {
    if (!ui || ui.root.hidden || !ui.processing.hidden) return; // never close mid-payment-confirmation
    if (state.step === 'pay') payExit('close');
    track('close', { detail: (state.step || '') + ' secs=' + stepSecs(), amount: cartAmount() });
    ui.root.classList.remove('ahc-in');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    setTimeout(function () { ui.root.hidden = true; }, 320);
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    btn.disabled = loading;
    btn.classList.toggle('disabled', loading);
    btn.classList.toggle('is-loading', loading);
    if (!loading && btn.dataset.ahcReady) syncPdpButtons(); // a sold-out PDP button stays off
    var loader = btn.querySelector('.ah-checkout-loader');
    if (loader) loader.style.display = loading ? 'flex' : 'none';
  }

  // ---- Step 1: mobile -----------------------------------------------------------------

  function cleanPhone(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length > 10 && /^(91|0)/.test(d)) d = d.slice(-10);
    return d.slice(0, 10);
  }

  // Arm "b": what they're buying and the order total, inside the phone card. Empty until the items are
  // priced (buy-now loads them just after the sheet opens; renderSummary() refills it then).
  var FREE_SHIP_FROM = 999; // the store's free-shipping promise (header bar, cart bar)
  function phoneOrderHtml() {
    var items = state.items || [];
    var t = state.totals || {};
    var total = totalOf(t);
    if (!items.length || total == null) return '';
    var bill = billRows(t);
    if (t.shipping_amount == null && total >= FREE_SHIP_FROM) {
      bill = bill.replace('<b>Calculated after address</b>', '<span class="ahc-free">FREE</span>');
    }
    return items.slice(0, 2).map(function (i) {
      return '<div class="ahc-line">' + thumb(i, 'with-qty') +
        '<div class="ahc-line-text"><div class="ahc-line-title">' + esc(i.title) + '</div>' +
        (i.variant ? '<div class="ahc-line-variant">' + esc(i.variant) + '</div>' : '') + '</div>' +
        '<div class="ahc-line-price">' + money(i.line) + '</div></div>';
    }).join('') +
      (items.length > 2 ? '<div class="ahc-line-variant">+ ' + (items.length - 2) + ' more</div>' : '') +
      '<div class="ahc-bill">' + bill + '</div>';
  }

  function renderPhoneStep(isBack) {
    setBack(null);
    var pane = showStep('phone',
      '<div class="ahc-card">' +
        (AB_PHONE === 'b' ? '<div class="ahc-phone-order" style="margin:0 0 16px;padding-bottom:12px;border-bottom:1px solid var(--ahc-line)"' + (phoneOrderHtml() ? '' : ' hidden') + '>' + phoneOrderHtml() + '</div>' : '') +
        '<h2 class="ahc-h">Enter your mobile number</h2>' +
        '<p class="ahc-sub">Used only for this order — confirmation and delivery updates on WhatsApp. We never share your number.</p>' +
        '<div class="ahc-field is-phone">' +
          '<input name="phone" id="ahc-f-phone" type="tel" inputmode="numeric" autocomplete="tel-national" placeholder=" " value="' + esc(state.customer.phone || '') + '">' +
          '<label for="ahc-f-phone">Mobile number</label>' +
          '<span class="ahc-prefix">' + I.flagIN + '+91</span><span class="ahc-field-ok">' + I.check + '</span></div>' +
        '<p class="ahc-field-msg" data-msg-for="phone"></p>' +
      '</div>' +
      '<div class="ahc-trust">' +
        '<div class="ahc-trust-item">' + I.shield + 'Secure, encrypted payments</div>' +
        '<div class="ahc-trust-item">' + I.card + 'UPI, cards & netbanking</div>' +
        '<div class="ahc-trust-item">' + I.india + 'Pan-India delivery</div>' +
      '</div>' +
      '<div class="ahc-accept"><div class="ahc-accept-label">We accept</div><div class="ahc-marks">' +
        '<span class="ahc-mark">' + MARK.upi + '</span><span class="ahc-mark">' + MARK.visa + '</span>' +
        '<span class="ahc-mark">' + MARK.mc + '</span><span class="ahc-mark">' + MARK.rupay + '</span>' +
      '</div></div>', isBack);

    var input = pane.querySelector('input');
    function sync() {
      var v = cleanPhone(input.value);
      if (v !== input.value) input.value = v;
      fieldError(input, '');
      markValid(input, /^[6-9][0-9]{9}$/.test(v));
      setCta('Continue', submit, { disabled: v.length !== 10 });
    }
    function submit() {
      var v = cleanPhone(input.value);
      if (!/^[6-9][0-9]{9}$/.test(v)) { fieldError(input, 'Please enter a valid 10-digit mobile number.'); input.focus(); return; }
      state.customer.phone = v;
      track('phone', Object.assign({ phone: v, amount: cartAmount(), items: itemsLabel() }, state.attribution));
      // Returning customer on this device: prefill the rest of the address from last time.
      var p = load(PROFILE_KEY);
      if (p && p.phone === v) {
        ['name', 'email'].forEach(function (k) { if (!state.customer[k]) state.customer[k] = p[k]; });
        if (!state.customer.address1) state.customer.address1 = [p.address1, p.address2].filter(Boolean).join(', ');
        if (!state.location.pincode && p.pincode) state.location = { pincode: p.pincode };
      }
      renderAddressStep();
    }
    input.addEventListener('input', sync);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') submit(); });
    sync();
    setTimeout(function () { input.focus(); }, 350);
  }

  // ---- Step 2: address ----------------------------------------------------------------

  function lookupPincode(pincode) {
    return fetch('https://api.postalpincode.in/pincode/' + pincode)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var po = data && data[0] && data[0].Status === 'Success' ? data[0].PostOffice[0] : null;
        return po ? { ok: true, city: po.District, province: po.State } : { ok: false, reason: 'notfound' };
      })
      .catch(function (err) {
        console.error('[ah-checkout] pincode lookup failed:', err);
        return { ok: false, reason: 'network' };
      });
  }

  function renderAddressStep(isBack) {
    var c = state.customer;
    var loc = state.location;
    setBack(renderPhoneStep);
    var pane = showStep('address',
      '<div class="ahc-card"><form id="ahc-address-form" novalidate autocomplete="on">' +
        '<h2 class="ahc-h">Delivery address</h2>' +
        '<p class="ahc-sub">Ordering as <b>+91 ' + esc(c.phone) + '</b> · <button type="button" class="ahc-link" data-ahc="edit-phone">Change</button></p>' +
        field('pincode', 'Pincode', loc.pincode, 'inputmode="numeric" autocomplete="postal-code" maxlength="6"', I.pin) +
        '<div class="ahc-grid-2" data-ahc="manual-city" hidden>' +
          '<div>' + field('city', 'City', loc.city, 'autocomplete="address-level2"') + '</div>' +
          '<div>' + field('province', 'State', loc.province, 'autocomplete="address-level1"') + '</div>' +
        '</div>' +
        field('address1', 'House no., street, area', c.address1, 'autocomplete="street-address" maxlength="250"', I.home, true) +
        '<div class="ahc-section-label" style="margin:14px 2px 10px">Contact details</div>' +
        field('name', 'Full name', c.name, 'autocomplete="name"', I.user) +
        field('email', 'Email (optional, for invoice)', c.email, 'type="email" inputmode="email" autocomplete="email"', I.mail) +
      '</form></div>', isBack);

    var form = pane.querySelector('form');
    var pin = form.elements.pincode;
    var pinMsg = pane.querySelector('[data-msg-for="pincode"]');
    var manual = pane.querySelector('[data-ahc="manual-city"]');
    var timer = null;
    var pending = null;

    pane.querySelector('[data-ahc="edit-phone"]').addEventListener('click', function () { renderPhoneStep(true); });

    function setPinMsg(cls, html) { pinMsg.className = 'ahc-field-msg ' + cls; pinMsg.innerHTML = html; }

    function tryLookup() {
      var v = pin.value.replace(/\D/g, '').slice(0, 6);
      if (v !== pin.value) pin.value = v;
      pin.closest('.ahc-field').classList.remove('is-invalid');
      markValid(pin, state.location.pincode === v && state.location.city);
      if (state.location.pincode === v && state.location.city) return pending;
      state.location = { pincode: v };
      manual.hidden = true;
      if (v.length !== 6) { setPinMsg('', ''); pending = null; return null; }
      setPinMsg('is-busy', 'Checking pincode…');
      pending = lookupPincode(v).then(function (r) {
        if (pin.value !== v) return;
        if (r.ok) {
          state.location = { pincode: v, city: r.city, province: r.province };
          setPinMsg('is-ok', I.check + esc(r.city + ', ' + r.province));
          markValid(pin, true);
        } else {
          // Lookup is only a convenience to auto-fill city/state — never block the sale on it
          // (service down, or a real pincode missing from its database). Customer types them.
          setPinMsg('', '');
          manual.hidden = false;
        }
      });
      return pending;
    }
    pin.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(tryLookup, 350); });
    form.addEventListener('input', function (e) {
      if (e.target.name !== 'pincode') fieldError(e.target, '');
    });
    form.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
    if (pin.value) tryLookup();

    function submit() {
      clearTimeout(timer);
      Promise.resolve(tryLookup()).then(validateAndQuote);
    }

    function validateAndQuote() {
      var f = form.elements;
      var firstBad = null;
      function need(input, ok, msg) { if (!ok) { fieldError(input, msg); firstBad = firstBad || input; } }
      var loc = state.location;
      if (!manual.hidden) {
        need(f.city, f.city.value.trim(), 'Enter your city.');
        need(f.province, f.province.value.trim(), 'Enter your state.');
        if (f.city.value.trim() && f.province.value.trim()) {
          loc = state.location = { pincode: pin.value, city: f.city.value.trim(), province: f.province.value.trim() };
        }
      }
      if (!/^[1-9][0-9]{5}$/.test(pin.value) || (!loc.city && manual.hidden)) {
        pin.closest('.ahc-field').classList.add('is-invalid');
        if (!pinMsg.textContent) setPinMsg('', 'Enter a valid 6-digit pincode.');
        firstBad = firstBad || pin;
      }
      need(f.address1, f.address1.value.trim().length >= 8, 'Enter your full address — house no., street and area.');
      need(f.name, f.name.value.trim().length >= 2, 'Enter your full name.');
      var email = f.email.value.trim();
      need(f.email, !email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email), 'Enter a valid email or leave it blank.');
      if (firstBad) { firstBad.focus(); return; }

      c.name = f.name.value.trim();
      c.email = email;
      // One free-form address box — collapse the newlines a textarea allows into a single line.
      c.address1 = f.address1.value.trim().replace(/\s*\n+\s*/g, ', ');
      c.address2 = '';
      save(PROFILE_KEY, { phone: c.phone, name: c.name, email: c.email, address1: c.address1, address2: c.address2, pincode: loc.pincode });

      var address = { address1: c.address1, address2: c.address2, city: loc.city, province: loc.province, pincode: loc.pincode };
      track('address', { phone: c.phone, amount: cartAmount(), detail: loc.pincode + ' ' + (loc.city || '') + (manual.hidden ? '' : ' (typed city)') });
      ctaLoading(true);
      api('cart_quote.php', Object.assign({ lines: state.lines, address: address, phone: c.phone, name: c.name, email: c.email, discount_codes: state.discountCodes }, state.attribution, clickIds()))
        .then(function (res) {
          state.token = res.token;
          state.totals = { subtotal_amount: res.subtotal_amount };
          state.rejectedCodes = (res.codes || []).filter(function (x) { return !x.applicable && !isClubCode(x.code); }).map(function (x) { return x.code; });
          var group = (res.delivery_groups || [])[0];
          if (!group || !group.options.length) throw new Error('We couldn\'t get shipping for this pincode. Please check it and try again.');
          // Cheapest option is auto-selected — no separate shipping-picker screen.
          var option = group.options.slice().sort(function (a, b) { return a.amount - b.amount; })[0];
          state.shippingTitle = option.title;
          return api('select_delivery.php', { token: state.token, delivery_group_id: group.delivery_group_id, option_handle: option.handle });
        })
        .then(function (res) {
          state.totals = res;
          renderSummary();
          renderPaymentStep();
        })
        .catch(function (err) { ctaLoading(false); track('quote_error', { detail: err.message, amount: cartAmount() }); showAlert(err.message); });
    }

    setCta('Continue to payment', submit);
    if (!pin.value) setTimeout(function () { pin.focus(); }, 350);
  }

  // ---- Step 3: payment ----------------------------------------------------------------

  function amounts() {
    var total = state.totals.total_amount;
    var deposit = Math.min(Math.max(PARTIAL_MIN, Math.ceil(total * PARTIAL_PERCENT / 100)), total);
    return { total: total, deposit: deposit, balance: total - deposit + COD_FEE };
  }

  // TEMPORARY price experiment (2026-10-19): a one-tap 10% offer beside the coupon field, for
  // shoppers looking for a discount — GoKwik showed its codes here and half its orders used one.
  // Only offered when no other discount applies (BONSAI10 doesn't combine with the automatic ones).
  // If it works, the plan is to raise list prices and keep it; to switch off, set OFFER = null.
  var OFFER = { code: 'BONSAI10', percent: 10, min: 500 };
  function offerFor(t) {
    if (!OFFER || t.discount_code || discountOf(t).amount > 0) return null;
    var sub = Number(t.subtotal_amount != null ? t.subtotal_amount : itemsSubtotal()) || 0;
    if (sub < OFFER.min) return null;
    return { code: OFFER.code, save: Math.floor(sub * OFFER.percent / 100) };
  }

  // Add-ons beside the total (api/addon.php): one row of two small tiles, so the payment methods stay
  // in view — the Essential Kit (scissors + fertiliser) when a bonsai order doesn't have it, and a
  // small plant at an add-on price (₹149 copies no coupon or offer applies to, tools/addon_products.py).
  // Picked once per checkout so an added tile stays put.
  var SHEARS = '50890362028339';
  var ADDONS = [
    { key: 'shears', variant: SHEARS, title: 'Essential Kit', price: 179, compare: 300,
      image: 'https://cdn.shopify.com/s/files/1/0918/8442/1427/files/bonsai_essential_items_free.jpg?v=1758248293' },
    { key: 'syngonium', variant: '67818858807603', title: 'Pink Syngonium', price: 149, compare: 225,
      image: 'https://cdn.shopify.com/s/files/1/0918/8442/1427/files/syngonium_indoor_plant.jpg?v=1768645036' },
    { key: 'monstera', variant: '67818858381619', title: 'Monstera Adansonii', price: 149, compare: 249,
      image: 'https://cdn.shopify.com/s/files/1/0918/8442/1427/files/Monstera__A_Unique_Green_Accent.jpg?v=1793021468' },
  ];
  function lineIndex(variant) {
    return (state.lines || []).map(function (l) { return variantNum(l.variant_id); }).indexOf(variant);
  }
  function addonItem(a) { return { title: a.title, variant: '', image: a.image, qty: 1, line: a.price, compare: a.compare }; }
  function addonRows() {
    if (!state.addonRows) {
      var bonsai = (state.lines || []).concat(state.items || []).some(function (l) { return /bonsai/i.test(l.title || ''); });
      var plants = ADDONS.slice(1).filter(function (a) { return lineIndex(a.variant) < 0; });
      state.addonRows = (bonsai && lineIndex(SHEARS) < 0 ? [ADDONS[0]] : []).concat(plants).slice(0, 2);
    }
    return state.addonRows;
  }

  function addonCard() {
    var rows = addonRows();
    if (!rows.length) return '';
    return '<div class="ahc-section-label" style="color:#d42a2a">Add gifts at massive discount</div>' +
      '<div class="ahc-card" style="padding:10px;display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:8px">' + rows.map(function (a) {
        var added = lineIndex(a.variant) >= 0;
        return '<div style="display:flex;gap:8px;align-items:center;min-width:0">' +
          '<div style="flex:0 0 48px;height:48px;border-radius:8px;background:#f2f2ee url(\'' + esc(sized(a.image, 120)) + '\') center/cover"></div>' +
          '<div style="flex:1;min-width:0">' +
            '<div style="font-size:13px;font-weight:700;line-height:1.2">' + money(a.price) + ' <s style="font-size:11px;font-weight:400;color:var(--ahc-muted)">' + money(a.compare) + '</s></div>' +
            '<div style="font-size:11px;color:var(--ahc-muted);line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + esc(a.title) + '</div>' +
            '<button type="button" class="ahc-coupon-apply" data-ahc="addon" data-variant="' + a.variant + '" style="height:26px;min-width:0;width:100%;margin-top:4px;border-radius:8px;font-size:12px' +
              (added ? ';background:none;color:var(--ahc-ink);box-shadow:inset 0 0 0 1px var(--ahc-line-strong)' : '') + '">' +
              '<span class="ahc-btn-label">' + (added ? '✓ Added' : 'Add') + '</span><span class="ahc-spin"></span></button>' +
          '</div></div>';
      }).join('') + '</div>';
  }

  function bindAddons(pane) {
    pane.querySelectorAll('[data-ahc="addon"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-variant');
        var a = ADDONS.filter(function (x) { return x.variant === v; })[0];
        var add = lineIndex(v) < 0;
        btn.classList.add('is-loading'); btn.disabled = true;
        ui.btn.disabled = true; // never pay mid-recalculation
        api('addon.php', { token: state.token, variant_id: v, add: add })
          .then(function (res) {
            track('addon', { detail: (add ? 'add ' : 'remove ') + a.key, amount: res.total_amount });
            var items = state.items || [];
            var aligned = items.length === state.lines.length; // items are cosmetic and may be missing
            if (add) {
              state.lines.push(res.line);
              if (aligned) items.push(addonItem(a));
            } else {
              var i = lineIndex(v);
              if (i >= 0) { state.lines.splice(i, 1); if (aligned) items.splice(i, 1); }
            }
            state.totals = res;
            renderSummary();
            renderPaymentStep(false, true);
          })
          .catch(function (err) {
            track('addon', { detail: 'failed ' + a.key + ': ' + err.message });
            renderPaymentStep(false, true);
            showAlert(err.message);
          });
      });
    });
  }

  function couponCard() {
    var t = state.totals;
    var d = discountOf(t);
    var html = '<div class="ahc-card ahc-coupon">';
    // Club member price: no Remove, no coupon box — one discount per order.
    if (isClubCode(t.discount_code)) {
      return html + '<div class="ahc-coupon-applied"><span class="ahc-coupon-ico">' + I.tag + '</span>' +
        '<div class="ahc-coupon-text"><b>Club member price</b> applied<small>You save ' + money(d.amount) + ' on this order</small></div></div>' +
        '<p class="ahc-coupon-note">Coupons can\'t be added to member prices.</p></div>';
    }
    var offer = state.couponSuggest ? null : offerFor(t);
    if (offer) {
      html += '<div class="ahc-offer-pick"><span class="ahc-coupon-ico">' + I.tag + '</span>' +
        '<div class="ahc-coupon-text"><b>' + OFFER.percent + '% off with ' + esc(offer.code) + '</b><small>Save ' + money(offer.save) + ' on this order</small></div>' +
        '<button type="button" class="ahc-coupon-apply" data-ahc="offer-apply" data-code="' + esc(offer.code) + '"><span class="ahc-btn-label">Apply</span><span class="ahc-spin"></span></button></div>';
    }
    if (t.discount_code) {
      html += '<div class="ahc-coupon-applied"><span class="ahc-coupon-ico">' + I.tag + '</span>' +
        '<div class="ahc-coupon-text"><b>' + esc(t.discount_code) + '</b> applied<small>You save ' + money(d.amount) + ' on this order</small></div>' +
        '<button type="button" class="ahc-link" data-ahc="coupon-remove">Remove</button></div>';
    } else {
      if (d.amount > 0) {
        html += '<div class="ahc-offer">' + I.spark + '<span><b>' + esc(d.label || 'Offer') + '</b> applied — you save ' + money(d.amount) + '</span></div>';
      }
      html += '<button type="button" class="ahc-coupon-toggle" data-ahc="coupon-toggle" aria-expanded="' + !!state.couponOpen + '">' +
        '<span class="ahc-coupon-ico">' + I.tag + '</span><span>Have a coupon code?</span><span class="ahc-coupon-cta">Apply' + I.chevron + '</span></button>' +
        '<div class="ahc-coupon-form"' + (state.couponOpen ? '' : ' hidden') + '>' +
          '<div class="ahc-coupon-row">' +
            '<div class="ahc-field"><input name="coupon" id="ahc-f-coupon" placeholder=" " autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="100" value="' + esc(state.couponDraft || '') + '">' +
              '<label for="ahc-f-coupon">Coupon code</label><span class="ahc-field-ico">' + I.tag + '</span></div>' +
            '<button type="button" class="ahc-coupon-apply" data-ahc="coupon-apply"><span class="ahc-btn-label">Apply</span><span class="ahc-spin"></span></button>' +
          '</div>' +
          '<p class="ahc-field-msg" data-msg-for="coupon">' + esc(state.couponError || '') + '</p>' +
          suggestRow() +
        '</div>';
    }
    if (state.rejectedCodes && state.rejectedCodes.length && !t.discount_code) {
      html += '<p class="ahc-coupon-note">Code ' + esc(state.rejectedCodes.join(', ')) + ' from your cart doesn\'t apply to this order.</p>';
    }
    return html + '</div>';
  }

  // When a typed code is refused, api/apply_coupon.php may name the best code that does work on this
  // cart (WINTER10/15/20, never more % than the code typed) — offered as a one-tap Apply.
  function suggestRow() {
    var g = state.couponSuggest;
    if (!g) return '';
    return '<div class="ahc-offer-pick" style="margin-top:8px"><span class="ahc-coupon-ico">' + I.tag + '</span>' +
      '<div class="ahc-coupon-text"><b>Best available coupon: ' + esc(g.code) + '</b><small>' + g.percent + '% off — save ' + money(g.save) + ' on this order</small></div>' +
      '<button type="button" class="ahc-coupon-apply" data-ahc="suggest-apply" data-code="' + esc(g.code) + '"><span class="ahc-btn-label">Apply</span><span class="ahc-spin"></span></button></div>';
  }

  function bindCoupon(pane) {
    var toggle = pane.querySelector('[data-ahc="coupon-toggle"]');
    var form = pane.querySelector('.ahc-coupon-form');
    var input = pane.querySelector('#ahc-f-coupon');
    var applyBtn = pane.querySelector('[data-ahc="coupon-apply"]');
    var removeBtn = pane.querySelector('[data-ahc="coupon-remove"]');

    function send(code, btn) {
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      ui.btn.disabled = true; // never pay mid-recalculation
      return api('apply_coupon.php', { token: state.token, code: code })
        .then(function (res) {
          track('coupon', { detail: (code || 'removed') + ' ok', amount: res.total_amount });
          state.totals = res;
          state.couponOpen = false; state.couponDraft = ''; state.couponError = '';
          state.couponSuggest = null;
          state.rejectedCodes = [];
          renderSummary();
          renderPaymentStep(false, true);
          if (code) {
            var applied = ui.pane.querySelector('.ahc-coupon-applied');
            if (applied) applied.classList.add('is-new');
          }
        })
        .catch(function (err) {
          var g = (err.data && err.data.suggest) || null;
          track('coupon', { detail: code + ' rejected' + (g ? ' → suggest ' + g.code : '') + ': ' + err.message });
          state.couponError = err.message;
          state.couponSuggest = g;
          renderPaymentStep(false, true);
          var i = ui.pane.querySelector('#ahc-f-coupon');
          if (i) { i.closest('.ahc-field').classList.add('is-invalid'); i.focus(); }
        });
    }

    if (toggle) toggle.addEventListener('click', function () {
      state.couponOpen = !state.couponOpen;
      form.hidden = !state.couponOpen;
      toggle.setAttribute('aria-expanded', String(state.couponOpen));
      if (state.couponOpen) input.focus();
    });
    if (input) {
      input.addEventListener('input', function () {
        input.value = input.value.toUpperCase().replace(/\s+/g, '');
        state.couponDraft = input.value;
        state.couponError = '';
        input.closest('.ahc-field').classList.remove('is-invalid');
        pane.querySelector('[data-msg-for="coupon"]').textContent = '';
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyBtn.click(); } });
    }
    if (applyBtn) applyBtn.addEventListener('click', function () {
      var code = input.value.trim();
      if (!code) { input.focus(); return; }
      send(code, applyBtn);
    });
    if (removeBtn) removeBtn.addEventListener('click', function () { send('', null); });
    var offerBtn = pane.querySelector('[data-ahc="offer-apply"]');
    if (offerBtn) offerBtn.addEventListener('click', function () { send(offerBtn.getAttribute('data-code'), offerBtn); });
    var suggestBtn = pane.querySelector('[data-ahc="suggest-apply"]');
    if (suggestBtn) suggestBtn.addEventListener('click', function () { send(suggestBtn.getAttribute('data-code'), suggestBtn); });
  }

  function renderPaymentStep(isBack, still) {
    var t = state.totals;
    var c = state.customer;
    var loc = state.location;
    var partial = state.paymentMode === 'partial';
    var a = amounts();
    if (!still) payViewStart();
    if (!still) track('payment_view', { amount: totalOf(t), detail: state.paymentMode + (discountOf(t).amount > 0 ? ' disc:' + (discountOf(t).label || '') : '') +
      (addonRows().length ? ' addons:' + addonRows().map(function (a) { return a.key; }).join(',') : '') });
    var payNow = partial ? a.deposit : a.total;
    setBack(renderAddressStep);

    var method = partial
      ? '<div class="ahc-method"><span class="ahc-badge-tag">CASH ON DELIVERY</span>' +
          '<div class="ahc-method-head"><span class="ahc-radio"></span><span class="ahc-method-name">Book now, pay rest on delivery</span><span class="ahc-method-amt">' + money(a.deposit) + '</span></div>' +
          '<p class="ahc-method-desc">' + (a.deposit > Math.ceil(a.total * PARTIAL_PERCENT / 100)
            ? 'Pay a ' + money(a.deposit) + ' booking amount online to confirm your order.'
            : 'Pay ' + PARTIAL_PERCENT + '% online to confirm your order.') + '</p>' +
          '<div class="ahc-split">' +
            '<div class="ahc-bill-row is-now"><span>Pay now</span><b>' + money(a.deposit) + '</b></div>' +
            '<div class="ahc-bill-row"><span>Pay on delivery <span class="ahc-cod-fee">incl. ' + money(COD_FEE) + ' COD fee</span></span><b>' + money(a.balance) + '</b></div>' +
          '</div>' +
          methodTiles() +
        '</div>'
      : '<div class="ahc-method">' +
          '<div class="ahc-method-head"><span class="ahc-radio"></span><span class="ahc-method-name">Pay online</span><span class="ahc-method-amt">' + money(a.total) + '</span></div>' +
          '<p class="ahc-method-desc">Instant order confirmation.</p>' +
          methodTiles() +
        '</div>';

    var pane = showStep('pay',
      '<div class="ahc-card ahc-recap-card">' +
        '<div class="ahc-recap"><div class="ahc-recap-ico">' + I.pin + '</div>' +
          '<div class="ahc-recap-text"><div class="ahc-recap-title">' + esc(c.name) + ' <span>· +91 ' + esc(c.phone) + '</span></div>' +
          '<p class="ahc-recap-addr">' + esc(c.address1 + (c.address2 ? ', ' + c.address2 : '') + ', ' + loc.city + ', ' + loc.province + ' ' + loc.pincode) + '</p></div>' +
          '<button type="button" class="ahc-link" data-ahc="edit-address">Edit</button></div>' +
        '<div class="ahc-ship-line">' + I.truck + '<span>' + esc(state.shippingTitle || 'Standard delivery') + '</span>' +
          (t.shipping_amount > 0 ? '<b>' + money(t.shipping_amount) + '</b>' : '<b class="ahc-free">FREE</b>') + '</div>' +
      '</div>' +
      couponCard() +
      addonCard() +
      '<div class="ahc-section-label">Payment method</div>' +
      method +
      '<div class="ahc-card"><div class="ahc-section-label" style="margin:0 0 6px">Price details</div><div class="ahc-bill" style="border:0;margin:0;padding:0">' + billRows(t) + '</div></div>',
      isBack, still);

    pane.querySelector('[data-ahc="edit-address"]').addEventListener('click', function () { renderAddressStep(true); });
    bindCoupon(pane);
    bindAddons(pane);
    bindMethodTiles(pane);
    setCta('Pay ' + money(payNow), startPayment, { lock: true });
    payViewScroll(); // how much shows without scrolling
    // App list not known yet (slow network)? Re-render in place once it is.
    if (!state.upiApps) detectUpiApps().then(function (u) { if (u.apps.length && state.step === 'pay') renderPaymentStep(false, true); });
  }

  function startPayment() {
    if (typeof window.Razorpay !== 'function') {
      showAlert('Payment window is still loading — please try again in a moment.');
      return;
    }
    var mode = state.paymentMode || 'full';
    if (state.watch) state.watch.done = true; // a retry supersedes any earlier watcher
    var watch = state.watch = { done: false, token: state.token };
    var payAmount = mode === 'partial' ? amounts().deposit : totalOf(state.totals);
    var picked = state.payMethod || defaultMethod();
    var app = picked.indexOf('upi:') === 0 ? picked.slice(4) : null;
    if (state.payView) state.payView.done = true; // tapped pay — not an exit
    track('pay_click', { amount: payAmount, detail: mode + ' ' + picked });
    pixelAddPaymentInfo(totalOf(state.totals), picked);
    ctaLoading(true);
    function verified(resp) {
      watch.done = true;
      ui.processing.hidden = false;
      // Razorpay has handed us a signed success, so the money is taken: never show "not completed".
      // If the order isn't there yet, say "payment received" and keep checking until it lands.
      function pending() {
        renderConfirmation({ status: 'processing' });
        watchForPayment(state.watch = { done: false, token: watch.token });
      }
      api('rzp_verify.php', resp)
        .then(function (v) { if (v.status === 'paid' || v.status === 'confirmed' || v.status === 'order_failed') renderConfirmation(v); else pending(); })
        .catch(pending);
    }
    var order = api('rzp_order.php', { token: state.token, payment_mode: mode, name: state.customer.name, phone: state.customer.phone, email: state.customer.email });
    if (app === 'qr') return payByQr(order, watch, payAmount, verified);
    if (app) {
      Promise.all([order, loadRzpCustom()]).then(function (r) {
        var o = r[0].options;
        var rzp = new r[1]({ key: o.key });
        rzp.on('payment.success', function (resp) { track('rzp_success', { amount: payAmount, detail: 'upi:' + app }); verified(resp); });
        rzp.on('payment.error', function (e) {
          var err = (e && (e.error || e)) || {};
          track('rzp_failed', { amount: payAmount, detail: ['upi:' + app, err.reason, err.description].filter(Boolean).join(' | ') });
          // Declined, cancelled in the app, or the app isn't installed. The order may still land
          // (the watcher keeps checking), but let them try again or pick another way.
          ctaLoading(false);
          showAlert('Payment didn\'t complete in ' + upiAppName(app) + '. Try again, or pick another app or method.');
        });
        rzp.createPayment({
          amount: o.amount, currency: o.currency, order_id: o.order_id, method: 'upi',
          contact: o.prefill.contact, email: o.prefill.email || 'void@razorpay.com',
          description: o.description,
        }, { app: app });
        track('rzp_open', { amount: payAmount, detail: 'upi:' + app });
        watchForPayment(watch);
        // The customer is now in their UPI app; if they come back without paying, re-enable Pay.
        setTimeout(function () { if (!watch.done) ctaLoading(false); }, 4000);
      }).catch(function (err) { ctaLoading(false); showAlert(err.message); });
      return;
    }
    order
      .then(function (res) {
        var options = res.options;
        options.prefill = Object.assign({}, options.prefill, { method: picked });
        options.handler = verified;
        options.modal = Object.assign({}, options.modal, { ondismiss: function () { track('rzp_dismiss', { amount: payAmount }); ctaLoading(false); } });
        var rzp = new window.Razorpay(options);
        // Failed attempts (wrong OTP, UPI declined, timed out…) — the sheet stays open for a retry.
        rzp.on('payment.failed', function (r) {
          var e = (r && r.error) || {};
          track('rzp_failed', { amount: payAmount, detail: [e.reason, e.step, e.description, e.metadata && e.metadata.payment_id].filter(Boolean).join(' | ') });
        });
        rzp.open();
        track('rzp_open', { amount: payAmount });
        watchForPayment(watch);
      })
      .catch(function (err) { ctaLoading(false); showAlert(err.message); });
  }

  // Desktop UPI: razorpay.js with flow 'qr' hands back the UPI link ('upi.qr' event) and we draw
  // the QR on our own page. That needs Razorpay's "UPI QR non-redirect" flag on the account — if
  // no QR arrives in a few seconds, open the standard Razorpay window straight on its UPI QR.
  // Off: the flag isn't enabled on Abana's account (tested 2026-10-20 — no 'upi.qr' event), so
  // desktop goes straight to Razorpay's window opened on its QR. Turn on if Razorpay enables it.
  var QR_INLINE = false;
  var QR_LIB = 'https://cdnjs.cloudflare.com/ajax/libs/qrcode-generator/1.4.4/qrcode.min.js';
  var qrLibLoading = null;
  function loadQrLib() {
    if (window.qrcode) return Promise.resolve(window.qrcode);
    return qrLibLoading || (qrLibLoading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = QR_LIB; s.async = true;
      s.onload = function () { window.qrcode ? resolve(window.qrcode) : reject(new Error('QR library missing')); };
      s.onerror = function () { qrLibLoading = null; reject(new Error('QR library failed to load')); };
      document.head.appendChild(s);
    }));
  }
  function openQrSheet(o, payAmount, verified) {
    // Razorpay's own window, opened on its UPI QR code.
    o.prefill = Object.assign({}, o.prefill, { method: 'upi' });
    o.handler = verified;
    o.config = { display: {
      blocks: { qr: { name: 'Scan the QR code with any UPI app', instruments: [{ method: 'upi', flows: ['qr'] }] } },
      sequence: ['block.qr'], preferences: { show_default_blocks: true },
    } };
    o.modal = { ondismiss: function () { track('rzp_dismiss', { amount: payAmount }); ctaLoading(false); } };
    var std = new window.Razorpay(o);
    std.on('payment.failed', function (r) {
      var e = (r && r.error) || {};
      track('rzp_failed', { amount: payAmount, detail: ['upi:qr-std', e.reason, e.description].filter(Boolean).join(' | ') });
    });
    std.open();
  }
  function payByQr(order, watch, payAmount, verified) {
    if (!QR_INLINE) {
      order.then(function (res) {
        openQrSheet(res.options, payAmount, verified);
        track('rzp_open', { amount: payAmount, detail: 'upi:qr' });
        watchForPayment(watch);
      }).catch(function (err) { ctaLoading(false); showAlert(err.message); });
      return;
    }
    var shown = false;
    Promise.all([order, loadRzpCustom(), loadQrLib().catch(function () { return null; })]).then(function (r) {
      var o = r[0].options, qr = r[2];
      var rzp = new r[1]({ key: o.key });
      rzp.on('payment.success', function (resp) { track('rzp_success', { amount: payAmount, detail: 'upi:qr' }); verified(resp); });
      rzp.on('payment.error', function (e) {
        var err = (e && (e.error || e)) || {};
        if (!shown) return; // no QR yet — the fallback below takes over
        track('rzp_failed', { amount: payAmount, detail: ['upi:qr', err.reason, err.description].filter(Boolean).join(' | ') });
        showAlert('The QR code payment didn\'t complete. Tap "UPI QR" for a new code, or pick another method.');
      });
      rzp.on('upi.qr', function (d) {
        var slot = ui.pane.querySelector('.ahc-qr-slot');
        if (!qr || !slot || !d || !d.qr_url || watch.done || state.watch !== watch) return;
        shown = true;
        var q = qr(0, 'M');
        q.addData(d.qr_url);
        q.make();
        slot.innerHTML = '<div class="ahc-qr">' + q.createSvgTag({ cellSize: 5, margin: 2, scalable: true }) +
          '<div class="ahc-qr-text"><b>Scan to pay ' + money(payAmount) + '</b>' +
          '<span>Open PhonePe, Google Pay, Paytm or any UPI app on your phone and scan this code.</span>' +
          '<span class="ahc-qr-wait"><span class="ahc-spin"></span>Waiting for your payment…</span></div></div>';
        ctaLoading(false);
        track('rzp_open', { amount: payAmount, detail: 'upi:qr shown' });
      });
      rzp.createPayment({
        amount: o.amount, currency: o.currency, order_id: o.order_id, method: 'upi',
        contact: o.prefill.contact, email: o.prefill.email || 'void@razorpay.com', description: o.description,
      }, { flow: 'qr' });
      watchForPayment(watch);
      setTimeout(function () {
        if (shown || watch.done || state.watch !== watch) return;
        openQrSheet(o, payAmount, verified);
        track('rzp_open', { amount: payAmount, detail: 'upi:qr fallback' });
      }, 6000);
    }).catch(function (err) { ctaLoading(false); showAlert(err.message); });
  }

  // Paying in another app (CRED, Amazon Pay, a UPI app) often means Razorpay's success handler
  // never runs in this tab, though the payment and the order (via webhook) go through — leaving
  // the customer staring at the payment step. So while a payment is open, ask our server every
  // few seconds (and right when the tab regains focus) whether the order exists yet.
  function watchForPayment(watch) {
    var started = Date.now();
    var timer = null;
    function check() {
      if (watch.done || state.watch !== watch) return stop();
      if (Date.now() - started > 15 * 60 * 1000) return stop();
      fetch((CFG.apiBase || '').replace(/\/$/, '') + '/api/order_status.php?t=' + encodeURIComponent(watch.token))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.ok || watch.done || state.watch !== watch) return;
          watch.done = true;
          stop();
          track('paid', { amount: cartAmount(), detail: (j.order && j.order.name || '') + ' via status check' });
          window.location.href = '/pages/order-confirmed?t=' + encodeURIComponent(watch.token);
        })
        .catch(function () { /* keep trying */ });
    }
    function onVisible() { if (document.visibilityState === 'visible') check(); }
    function stop() {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    }
    timer = setInterval(check, 4000);
    document.addEventListener('visibilitychange', onVisible);
  }

  function renderConfirmation(res) {
    var st = res.status === 'confirmed' ? 'paid' : res.status;
    track(['paid', 'processing', 'order_failed'].indexOf(st) > -1 ? st : 'unpaid', { amount: cartAmount(), detail: res.order_name || res.status || '' });
    if (res.status === 'paid' || res.status === 'confirmed') {
      // Our own hosted confirmation page — Shopify's native order_status_url is gated behind
      // Protected Customer Data access we don't have, so it reads from our DB via order_status.php.
      window.location.href = '/pages/order-confirmed?t=' + encodeURIComponent(state.token);
      return;
    }
    ui.processing.hidden = true;
    setBack(null);
    if (res.status === 'processing') {
      showStep('done',
        '<div class="ahc-card ahc-result"><div class="ahc-result-ico is-ok">' + I.check + '</div>' +
        '<h2 class="ahc-h">Payment received</h2><p>We\'re finishing up your order — you\'ll get a confirmation on +91 ' + esc(state.customer.phone) + ' shortly.</p></div>');
      setCta('Continue shopping', function () { window.location.href = '/'; });
    } else if (res.status === 'order_failed') {
      // Money was taken but the Shopify order couldn't be created — ops has been alerted.
      // Don't tell them the payment failed (it didn't) or promise a refund we can't guarantee.
      showStep('done',
        '<div class="ahc-card ahc-result"><div class="ahc-result-ico is-ok">' + I.check + '</div>' +
        '<h2 class="ahc-h">Payment received</h2><p>We hit a snag confirming your order. Our team will call you on +91 ' + esc(state.customer.phone) + ' shortly to sort it out — no need to pay again.</p></div>');
      setCta('Continue shopping', function () { window.location.href = '/'; });
    } else {
      showStep('done',
        '<div class="ahc-card ahc-result"><div class="ahc-result-ico is-bad">' + I.alert + '</div>' +
        '<h2 class="ahc-h">Payment not completed</h2><p>If any amount was deducted, it will be refunded automatically to your original payment method.</p></div>');
      setCta('Try again', function () { renderPaymentStep(true); });
    }
  }

  // ---- Entry points -------------------------------------------------------------------

  function attribution() {
    var params = new URLSearchParams(window.location.search);
    // This page's own UTMs win; otherwise the ad landing page's (saved by CLICK above).
    var utm = params.get('utm_source') ? {} : ((CLICK.landing && CLICK.landing.v) || {});
    return {
      utm_source: params.get('utm_source') || utm.utm_source || '',
      utm_campaign: params.get('utm_campaign') || utm.utm_campaign || '',
      utm_medium: params.get('utm_medium') || utm.utm_medium || '',
      utm_content: params.get('utm_content') || utm.utm_content || '',
      landing_url: window.location.href,
    };
  }

  // A Shopify discount link (/discount/CODE) leaves the code in the discount_code cookie; Buy now skips
  // the cart, so pick it up here (Abana Club drop links rely on this). Shopify decides if it applies.
  function linkCodes() {
    var m = document.cookie.match(/(?:^|; )discount_code=([^;]+)/);
    var c = m ? decodeURIComponent(m[1]).trim() : '';
    var codes = uniq((c ? [c] : []).concat(clubCodes()));
    return codes.length ? { discountCodes: codes } : {};
  }

  // A Club member's sale codes (CLUB-XXXXXX, CLUB-XXXXXX-2 …, one per member price), set on
  // .abanahomes.com by club.abanahomes.com/api/drop/buy. Shopify applies only those that match the
  // items, so they always ride along — Buy now and cart alike.
  function clubCodes() {
    var m = document.cookie.match(/(?:^|; )ah_club_codes=([^;]+)/);
    if (!m) return [];
    return decodeURIComponent(m[1]).split(',').map(function (x) { return x.trim(); })
      .filter(function (x) { return /^CLUB-[A-Z0-9-]{4,20}$/i.test(x); }).slice(0, 5);
  }
  function isClubCode(c) { return /^CLUB-/i.test(c || ''); }
  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }

  function startWith(lines, items, btn, mode, extra) {
    state = Object.assign({
      lines: lines, items: items || [], token: null, totals: {}, customer: {}, location: {},
      attribution: attribution(), paymentMode: mode || 'full', step: null,
      discountCodes: [], preDiscount: null, rejectedCodes: [],
      attempt: rid(), entry: mode === 'partial' ? 'book' : 'buynow',
    }, extra || {});
    var p = load(PROFILE_KEY);
    if (p && p.phone) state.customer.phone = p.phone;
    setLoading(btn, false);
    open();
    renderPhoneStep();
    detectUpiApps(); // warm razorpay.js + the app list while they fill in phone/address
    track('open', { amount: cartAmount(), detail: itemsLabel().slice(0, 200) + (p && p.phone ? ' [returning device]' : '') });
    if (state.entry === 'cart') pixelBeginCheckout();
  }

  function productItems(variantId, quantity) {
    // Product JSON for thumbnails/titles in the summary — purely cosmetic, so failures are ignored.
    var m = window.location.pathname.match(/^(.*\/products\/[^/?#]+)/);
    if (!m) return Promise.resolve([]);
    return fetch(m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = (p.variants || []).filter(function (x) { return String(x.id) === String(variantId); })[0] || (p.variants || [])[0];
      if (!v) return [];
      return [{
        product_id: p.id,
        title: p.title,
        variant: v.public_title || '',
        image: (v.featured_image && v.featured_image.src) || p.featured_image,
        qty: quantity,
        line: (v.price / 100) * quantity,
        compare: v.compare_at_price ? (v.compare_at_price / 100) * quantity : 0,
      }];
    }).catch(function () { return []; });
  }

  function buyNow(btn, mode) {
    // The button is a sibling block in the product section, not a descendant of <product-form>
    // (each section block renders its own self-contained markup) — so look for the page's form.
    var productForm = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
    if (!productForm) { console.error('[ah-checkout] no product form on this page'); return; }
    var add = nativeAddButton();
    if (!add || add.disabled) { syncPdpButtons(); return; } // sold out / unavailable variant
    var data = new FormData(productForm);
    var variantId = data.get('id');
    var quantity = parseInt(data.get('quantity') || '1', 10);
    // The scissors box ticked on the product page (snippets/ah-shears-addon.liquid) adds them to the theme
    // cart, which Buy now doesn't use — carry them into this order.
    var shears = document.querySelector('[data-ah-addon-check]:checked');
    var lines = [{ variant_id: variantId, quantity: quantity }];
    if (shears && shears.getAttribute('data-variant-id') !== String(variantId)) lines.push({ variant_id: shears.getAttribute('data-variant-id'), quantity: 1, title: ADDONS[0].title });
    startWith(lines, [], btn, mode, linkCodes());
    productItems(variantId, quantity).then(function (items) {
      if (state.lines[0].variant_id !== variantId) return;
      if (items.length) {
        state.items = state.lines.length > 1 ? items.concat(addonItem(ADDONS[0])) : items;
        state.lines[0].title = items[0].title;
        state.lines[0].product_id = items[0].product_id;
        renderSummary();
      }
      pixelBeginCheckout(); // after the price is known, so the event carries a value
    });
  }

  // Codes applied in the theme's cart drawer (sticky in the cart cookie) — carried into checkout.
  function cartDiscounts(cart) {
    var codes = [], label = null;
    function add(app) {
      if (!app) return;
      label = label || app.title || app.key || null;
      if (app.type === 'discount_code' && (app.title || app.key)) codes.push(app.title || app.key);
    }
    (cart.discount_codes || []).forEach(function (c) { if (c.applicable !== false && c.code) codes.push(c.code); });
    (cart.cart_level_discount_applications || []).forEach(add);
    (cart.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) { add(a.discount_application); });
    });
    return { codes: codes.filter(function (c, i) { return codes.indexOf(c) === i; }), label: label };
  }

  function openFromCart(btn) {
    setLoading(btn, true);
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items.length) { setLoading(btn, false); return; }
      var lines = cart.items.map(function (i) { return { variant_id: i.variant_id, product_id: i.product_id, quantity: i.quantity, title: i.product_title }; });
      var items = cart.items.map(function (i) {
        return {
          title: i.product_title,
          variant: i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '',
          image: i.image,
          qty: i.quantity,
          line: i.original_line_price / 100, // pre-discount; discounts show as their own bill row
          compare: 0,
        };
      });
      var d = cartDiscounts(cart);
      startWith(lines, items, btn, 'full', {
        entry: 'cart',
        discountCodes: uniq(d.codes.concat(clubCodes())),
        preDiscount: cart.total_discount > 0 ? { amount: cart.total_discount / 100, label: d.label } : null,
      });
    }).catch(function () { setLoading(btn, false); });
  }

  // "Add to Cart" delegates entirely to Dawn's own native add-to-cart button — we don't
  // reimplement cart-add or drawer-open logic, just trigger the real one already on the page.
  function addToCart(btn) {
    var nativeBtn = document.querySelector('product-form form button[name="add"]');
    if (!nativeBtn) return;
    setLoading(btn, true);
    nativeBtn.click();
    setTimeout(function () { setLoading(btn, false); }, 1000);
  }

  // Buttons render disabled until this script is ready. Only newly seen buttons are enabled
  // (flagged), so one mid-checkout in its loading state is never re-enabled by accident.
  function enableButtons() {
    document.querySelectorAll('#ah-checkout-add-to-cart, .ah-checkout-launch__button').forEach(function (b) {
      if (b.dataset.ahcReady) return;
      b.dataset.ahcReady = '1';
      b.disabled = false;
      b.classList.remove('disabled');
    });
    syncPdpButtons();
  }
  // Buy Now / Book follow the native Add-to-cart button, which Dawn disables for a sold-out or
  // unavailable variant (and re-evaluates on every variant change) — never sell what ATC won't.
  function nativeAddButton() {
    return document.querySelector('product-form form button[name="add"]') || document.querySelector('form[action*="/cart/add"] button[name="add"]');
  }
  function syncPdpButtons() {
    var add = nativeAddButton();
    var soldOut = !add || add.disabled;
    document.querySelectorAll('#ah-checkout-buy-now, #ah-checkout-book-now').forEach(function (b) {
      if (b.classList.contains('is-loading')) return; // mid-checkout — setLoading owns it
      b.dataset.ahcReady = '1';
      // Only touch the attribute on a real change — rewriting it would re-trigger the observer.
      if (b.disabled !== soldOut) b.disabled = soldOut;
      b.classList.toggle('disabled', soldOut);
      b.classList.toggle('ahc-sold-out', soldOut);
    });
  }
  function watchButtons() {
    enableButtons();
    if (!('MutationObserver' in window)) return;
    // Dawn re-renders the cart drawer / cart page HTML after every cart change, which brings back
    // a fresh disabled Checkout button — enable those as they appear.
    new MutationObserver(enableButtons).observe(document.body, { childList: true, subtree: true });
    // Variant switches flip the native ATC's disabled attribute in place (no childList change).
    new MutationObserver(syncPdpButtons).observe(document.body, { attributes: true, attributeFilter: ['disabled'], subtree: true });
  }
  if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', watchButtons);
  else watchButtons();

  window.AHCheckout = {
    buyNow: buyNow,
    openFromCart: openFromCart,
    addToCart: addToCart,
    renderPhoneStep: renderPhoneStep,
    renderAddressStep: renderAddressStep,
    renderPaymentStep: renderPaymentStep,
    trackPurchase: trackPurchase,
  };
})();
